module.exports = __webpack_public_path__ + "img/success-32.b91b49be.svg";